<ckeditor
  [editor]="messageEditor"
  [config]="messageEditorConfig"
  #messageEditorComponent
  id="messageBody"
  name="messageBody"
  (ready)="onEditorReady($event)"
  [(ngModel)]="messageToSend"
  (ngModelChange)="onMessageToSendChanged()">
</ckeditor>
